import { useEffect } from 'react';

function useScrollToAnchor(headerHeight = 0) {
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash.slice(1); // Remove the '#' character

      if (hash) {
        const element: HTMLElement | null = document.querySelector(
          `[data-collection-id='${hash}']`
        );

        if (element) {
          element.style.scrollMarginTop = `${headerHeight}px`;

          const prefersReducedMotion = window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches;

          // Scroll the element into view
          element.scrollIntoView({
            behavior: prefersReducedMotion ? 'instant' : 'smooth',
            block: 'start'
          });
        }
      }
    };

    // Run on initial load in case there is already a hash in the URL
    handleHashChange();

    // Attach event listener to handle changes in the URL fragment
    window.addEventListener('hashchange', handleHashChange);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, [headerHeight]); // Re-run the effect if the header height changes
}

export default useScrollToAnchor;
